import * as React from 'react';

import {IDocument, ProductLine} from '../../../../../../infrastructure/interfaces';
import circleStylesLovelandCatalog from '../circleStylesLovelandCatalog';
import circleStylesDynaGroCatalog from '../circleStylesDynaGroCatalog';
import circleStylesDynaGroBrochure from '../circleStylesDynaGroBrochure';
import circleStylesLovelandBrochure from '../circleStylesLovelandBrochure';
import circleStylesProvenBrochure from '../circleStylesProvenBrochure';
import circleStylesProvenCatalog from '../circleStylesProvenCatalog';
import CropImage from './CropImage';
import { placeholderTypes } from '../../../../../../infrastructure/placeholderTypes';
import { removeDuplicates } from '../../../../../../lib/helpers';
import { isUSA } from '../../../../../../config';

export interface IFrontLayoutProps {
  isSpreadView: boolean;
  document: IDocument | null;
  isEditorRendering: boolean;
  mainView: boolean;
  isWebPageCover: boolean;
  moveCrop?(dragIndex: number, hoverIndex: number): void;
}

export interface IFrontLayoutState { }

export default class FrontLayout extends React.Component<IFrontLayoutProps, IFrontLayoutState> {


    filterDisclaimers() {
        let disclaimers: Array<any> = [];
        this.props.document!.pages.forEach((page) => {
          if (page) {
            page.placeholders.forEach((placeholder) => {
              if (placeholder.type === placeholderTypes.Product && placeholder.data
                && this.props.document!.type !== 'Catalog') {
                disclaimers.push(...placeholder.data.disclaimers!);
              }
            });
          }
        });
    
        disclaimers = removeDuplicates(disclaimers, 'value');
        return disclaimers;
      }


  render() {
      const titleLines =
        this.props.document && this.props.document.title
          ? this.props.document.title.split("<br/>")
          : ["Advanced", "Solutions", "to Maximize", "Crop Outcomes"];

      const isDynaGroCover = (!!this.props.document) && (!!this.props.document.coverImage) && (this.props.document!.coverImage!.coverType == ProductLine.SEED);
      
      switch (this.props.document!.type) {
          case 'Catalog': {
              return isDynaGroCover 
              ? (isUSA() ? this.renderDynaGroCatalogCover(titleLines) : this.renderProvenCatalogCover(titleLines))
              : this.renderLovelandCatalogCover(titleLines);
          }
          case 'Brochure': {
              return isDynaGroCover
              ? (isUSA() ? this.renderDynaGroBrochureCover() : this.renderProvenBrochureCover(titleLines))
              : this.renderLovelandBrochureCover(titleLines);
          }
          case 'Postcard': {
              return this.renderPostcardFront();
          }
          case 'Poster': {
              return this.renderPosterFront();
          }
      }
      return (<div></div>);
  }

  renderProvenCatalogCover(titleLines: string[]) {
  
    const {
        document,
        isSpreadView,
        isEditorRendering,
        isWebPageCover,
    } = this.props;
  
    if ((document == undefined) || (document.coverImage == undefined)) {
        return (<div></div>);
    }
    const { crops } = document!;
    const style = circleStylesProvenCatalog[crops.length] || { children: [] };
    const imgStyle = style.imgStyle;
  
      return (
          <div
              className={`front-cover-page `}
              style={isSpreadView ? {} : { left: "0rem" }}>
              <img className="cover-page"
                   src={
                       isWebPageCover
                           ? document.coverImage!.web.frontCover
                           : document.coverImage!.print.fullCover
                   }
                   alt={document.coverImage!.title} />
              <div className="front-title-proven-catalog">
                  {
                      titleLines.map(line =>
                          <p>{line}</p>
                      )
                  }
              </div>
              <div className="front-crops-wrapper">
                  {crops.map((c, i) =>
                      isEditorRendering ?
                          <CropImage
                              key={c.name}
                              id={c.name}
                              crop={c}
                              index={i}
                              moveCrop={this.props.moveCrop}
                              imgStyle={imgStyle}
                              style={style.children[i]}
                          />
                          :
                          <div
                              className="front-cover-crop"
                              key={i}
                              style={{ ...style.children[i] }}
                          >
                              <img
                                  alt={c.name}
                                  src={c.defaultImage}
                                  style={imgStyle}
                              />
                          </div>)
                  }
              </div>
  
              <div className="front-additional">
                  {
                      document!.additionalInfo.isEnabled ?
                          <div className="additional-info-front-proven-catalog">
                              <div className="additional-text-front-proven-catalog">{document!.additionalInfo.text}</div>
                              <div className="additional-date-front-proven-catalog">{document!.additionalInfo.date}</div>
                          </div> : null
  
                  }
              </div>
          </div>
      );
  }

  renderDynaGroCatalogCover(titleLines: string[]) {

      const {
          document,
          isSpreadView,
          isEditorRendering,
          isWebPageCover,
      } = this.props;

      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }
      const { crops } = document!;
      const style = circleStylesDynaGroCatalog[crops.length] || { children: [] };
      const imgStyle = style.imgStyle;

        return (
            <div
                className={`front-cover-page `}
                style={isSpreadView ? {} : { left: "0rem" }}>
                <img className="cover-page"
                     src={
                         isWebPageCover
                             ? document.coverImage!.web.frontCover
                             : document.coverImage!.print.fullCover
                     }
                     alt={document.coverImage!.title} />
                <div className="front-title-dynagro-catalog">
                    {
                        titleLines.map(line =>
                            <p>{line}</p>
                        )
                    }
                </div>
                <div className="front-crops-wrapper">
                    {crops.map((c, i) =>
                        isEditorRendering ?
                            <CropImage
                                key={c.name}
                                id={c.name}
                                crop={c}
                                index={i}
                                moveCrop={this.props.moveCrop}
                                imgStyle={imgStyle}
                                style={style.children[i]}
                            />
                            :
                            <div
                                className="front-cover-crop"
                                key={i}
                                style={{ ...style.children[i] }}
                            >
                                <img
                                    alt={c.name}
                                    src={c.defaultImage}
                                    style={imgStyle}
                                />
                            </div>)
                    }
                </div>

                <div className="front-additional">
                    {
                        document!.additionalInfo.isEnabled ?
                            <div className="additional-info-front-dynagro-catalog">
                                <div className="additional-text-front-dynagro-catalog">{document!.additionalInfo.text}</div>
                                <div className="additional-date-front-dynagro-catalog">{document!.additionalInfo.date}</div>
                            </div> : null

                    }
                </div>
            </div>
        );
    }

  renderDynaGroBrochureCover() {

      const {
          document,
          isSpreadView,
          isWebPageCover,
          isEditorRendering,
      } = this.props;

      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }
      const { crops } = document!;
      const style = circleStylesDynaGroBrochure[crops.length] || { children: [] };
      const imgStyle = style.imgStyle;

      return (
          <div
              className={`front-cover-page `}
              style={isSpreadView ? {} : { left: "0rem" }}>
              <img className="cover-page"
                   src={
                       isWebPageCover
                           ? document.coverImage!.web.frontCover
                           : document.coverImage!.print.fullCover
                   }
                   alt={document.coverImage!.title} />
              <div className="front-title-dyna-gro-brochure">
                  {
                      document!.additionalInfo.isEnabled ?
                          <div>
                            <p>{document!.additionalInfo.date}</p>
                            <p>{document!.additionalInfo.text}</p>
                          </div>
                        : null
                  }
              </div>
              <div className="front-crops-wrapper">
                  {crops.map((c, i) =>
                      isEditorRendering ?
                          <CropImage
                              key={c.name}
                              id={c.name}
                              crop={c}
                              index={i}
                              moveCrop={this.props.moveCrop}
                              imgStyle={imgStyle}
                              style={style.children[i]}
                          />
                          :
                          <div
                              className="front-cover-crop"
                              key={i}
                              style={{ ...style.children[i] }}
                          >
                              <img
                                  alt={c.name}
                                  src={c.defaultImage}
                                  style={imgStyle}
                              />
                          </div>)
                  }
              </div>
          </div>
        );
    }

  renderProvenBrochureCover(titleLines: string[]) {
    
      const {
          document,
          isSpreadView,
          isWebPageCover,
          isEditorRendering,
      } = this.props;
    
      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }
      const { crops } = document!;
      const style = circleStylesProvenBrochure[crops.length] || { children: [] };
      const imgStyle = style.imgStyle;
    
      return (
          <div
              className={`front-cover-page `}
              style={isSpreadView ? {} : { left: "0rem" }}>
              <img className="cover-page"
                   src={
                       isWebPageCover
                           ? document.coverImage!.web.frontCover
                           : document.coverImage!.print.fullCover
                   }
                   alt={document.coverImage!.title} />
              <div className="front-title-proven-brochure">
                  {
                      titleLines.map(line =>
                          <p>{line}</p>
                      )
                  }
              </div>
              <div className="front-additional-proven-brochure">
                  {
                      document!.additionalInfo.isEnabled ?
                          <div>
                            <p>{document!.additionalInfo.date}</p>
                            <p>{document!.additionalInfo.text}</p>
                          </div>
                        : null
                  }
              </div>
              <div className="front-crops-wrapper">
                  {crops.map((c, i) =>
                      isEditorRendering ?
                          <CropImage
                              key={c.name}
                              id={c.name}
                              crop={c}
                              index={i}
                              moveCrop={this.props.moveCrop}
                              imgStyle={imgStyle}
                              style={style.children[i]}
                          />
                          :
                          <div
                              className="front-cover-crop"
                              key={i}
                              style={{ ...style.children[i] }}
                          >
                              <img
                                  alt={c.name}
                                  src={c.defaultImage}
                                  style={imgStyle}
                              />
                          </div>)
                  }
              </div>
          </div>
        );
    }

    renderLovelandCatalogCover(titleLines: string[]) {

        const {
            document,
            isSpreadView,
            isEditorRendering,
            isWebPageCover,
        } = this.props;

        if ((document == undefined) || (document.coverImage == undefined)) {
            return (<div></div>);
        }

        const { crops } = document!;
        const style = circleStylesLovelandCatalog[crops.length] || { children: [] };
        const imgStyle = style.imgStyle;

        return (
            <div
                className={`front-cover-page front-cover-page--${crops.length}`}
                style={isSpreadView ? {} : { left: "0rem" }}>
                <img className="cover-page"
                     src={
                         isWebPageCover
                             ? document!.coverImage!.web.frontCover
                             : document!.coverImage!.print.fullCover
                     }
                     alt={document!.coverImage!.title} />
                <div className="front-title-loveland-catalog">
                    {
                        titleLines.map(line =>
                            <p>{line}</p>
                        )
                    }
                </div>
                <div className="front-crops-wrapper">
                    {crops.map((c, i) =>
                        isEditorRendering ?
                            <CropImage
                                key={c.name}
                                id={c.name}
                                crop={c}
                                index={i}
                                moveCrop={this.props.moveCrop}
                                imgStyle={imgStyle}
                                style={style.children[i]}
                            />
                            :
                            <div
                                className="front-cover-crop"
                                key={i}
                                style={{ ...style.children[i] }}
                            >
                                <img
                                    alt={c.name}
                                    src={c.defaultImage}
                                    style={imgStyle}
                                />
                            </div>)
                    }
                </div>

                <div className="front-additional">
                    {
                        document!.additionalInfo.isEnabled ?
                            <div>
                                <div className="additional-text-front-loveland-catalog">{document!.additionalInfo.text}</div>
                                <div className="additional-date-front-loveland-catalog">{document!.additionalInfo.date}</div>
                            </div> : null

                    }
                </div>

                {
                    document.companyInfo.isEnabled ?
                        <div className="division-name-loveland-catalog">
                            <p className="label">
                                {document.companyInfo.divisionName}
                            </p>
                            <p className="label">
                                {document.companyInfo.phoneNumber}
                            </p>
                            <p className="label">
                                {document.companyInfo.email}
                            </p>
                        </div> : null
                }

                <div className="front-branding-loveland-catalog">
                    {
                        document!.branding &&
                        <img
                            src={isEditorRendering ?
                                document!.branding.image :
                                document!.branding.image}
                            alt={document!.branding.title}
                        />
                    }
                </div>
            </div>
        );
    }

  renderLovelandBrochureCover(titleLines: string[]) {

      const {
          document,
          isSpreadView,
          isEditorRendering,
          isWebPageCover,
      } = this.props;

      const { crops } = document!;
      const style = circleStylesLovelandBrochure[crops.length] || { children: [] };
      const imgStyle = style.imgStyle;
      const year = new Date().getFullYear();

      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }

      return (
          <div
              className={`front-cover-page front-cover-page--${crops.length}`}
              style={isSpreadView ? {} : { left: "0rem" }}>
              <img className="cover-page"
                   src={
                       isWebPageCover
                           ? document.coverImage!.web.frontCover
                           : document.coverImage!.print.fullCover
                   }
                   alt={document.coverImage!.title} />


              <div className="front-title-loveland-brochure">
                  {
                      titleLines.map(line =>
                          <p>{line}</p>
                      )
                  }
              </div>
              <div className="front-crops-wrapper">
                  {crops.map((c, i) =>
                      isEditorRendering ?
                          <CropImage
                              key={c.name}
                              id={c.name}
                              crop={c}
                              index={i}
                              moveCrop={this.props.moveCrop}
                              imgStyle={imgStyle}
                              style={style.children[i]}
                          />
                          :
                          <div
                              className="front-cover-crop"
                              key={i}
                              style={{ ...style.children[i] }}
                          >
                              <img
                                  alt={c.name}
                                  src={c.defaultImage}
                                  style={imgStyle}
                              />
                          </div>)
                  }
              </div>

              <div className="front-additional">
                  {
                      document!.additionalInfo.isEnabled ?
                          <div>
                              <div className="additional-text-front-loveland-brochure">{document!.additionalInfo.text}</div>
                              <div className="additional-date-front-loveland-brochure">{document!.additionalInfo.date}</div>
                          </div> : null

                  }
              </div>

              <div className="front-branding-loveland-brochure">
                  {
                      document!.branding &&
                      <img
                          src={isEditorRendering ?
                              document!.branding.image :
                              document!.branding.image}
                          alt={document!.branding.title}
                      />
                  }
              </div>
              <div className="copyright-loveland-brochure">
                  <p>
                      LOVELAND PRODUCTS, INC.®<br/>
                      P.O. BOX 1286 | GREELEY, CO 80632<br/>
                      www.LovelandProducts.com
                  </p>
                  <p>
                      <b>ALWAYS READ AND FOLLOW LABEL DIRECTIONS.</b>
                  </p>
                  <p>
                      {"© " + year + " Loveland Products, Inc. All Rights Reserved."}<br/>
                      All of the trademarks and service marks displayed are marks of their respective owners.<br/>
                      Check State Registration to make sure product is registered in your state.
                  </p>
              </div>
          </div>
      );
  }

  renderPostcardFront() {
    const {
        document,
    } = this.props;

    if ((document == undefined) || (document.postcardImageFront == undefined)) {
        return (<div></div>);
    }

    return (
        <div className="front-cover-postcard-container">
              <img className="postcard-image-container" src={ document.postcardImageFront.image_src } />
        </div>
    );
  }

  renderPosterFront() {
    const {
        document,
    } = this.props;

    if ((document == undefined) || (document.posterImageBackground == undefined)) {
        return (<div></div>);
    }
    const imageSource = this.props.isEditorRendering
        ? document.posterImageBackground.web_image_path
        : document.posterImageBackground.image_src;

    const disclaimers = this.filterDisclaimers();

    return (
        <div className="front-cover-poster-container">
            <img className="poster-image-container" src={ imageSource } />
            <div className="front-title-poster">
                {document.additionalInfo.text}
            </div>
            <div className="disclaimers-poster">
                {
                    disclaimers ? disclaimers.filter(d => d.value !== '#').map((el, i) => {
                    return (
                        <div key={i}>
                        <p dangerouslySetInnerHTML={{ __html: el.description }}></p>
                        </div>
                    );
                    }) :
                    null
                }
            </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/FrontLayout/FrontLayout.tsx